import { GridPaginationModel } from '@mui/x-data-grid-pro';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getJamfAssets } from './actions';
import { INITIAL_STATE } from './constants';

export const jamfAssetsSlice = createSlice({
  name: 'jamfAssets',
  initialState: INITIAL_STATE(),
  reducers: {
    setPaginationModel: (state, action: PayloadAction<GridPaginationModel>) => {
      state.paginationModel = action.payload;
    },
    resetJamfAssetsState: () => INITIAL_STATE(),
  },
  extraReducers: (builder) => {
    builder.addCase(getJamfAssets.pending, (state) => {
      state.jamfAssetsLoadingState = 'pending';
    });
    builder.addCase(getJamfAssets.fulfilled, (state, action) => {
      state.jamfAssetsLoadingState = 'fulfilled';
      state.jamfAssets = action.payload.assets;
      state.count = action.payload.count;
    });
    builder.addCase(getJamfAssets.rejected, (state) => {
      state.jamfAssetsLoadingState = 'rejected';
    });
  },
});

export const { setPaginationModel, resetJamfAssetsState } = jamfAssetsSlice.actions;
export { getJamfAssets } from './actions';
export default jamfAssetsSlice.reducer;
